import api from '..';

function getDataRequest({
  country,
  city,
  partner,
  service,
  isSub = false,
}, name) {
  const request = name === 'excursion' ? {} : {
    Full: true,
  };
  let sname = '';
  if (country) {
    request.CountryId = typeof country?.value === 'undefined' ? country : country.value;
    sname += `/country:${request.CountryId}`;
  }
  if (city) {
    request.CityId = typeof city?.value === 'undefined' ? city : city.value;
    sname += `/city:${request.CityId}`;
  }
  if (partner) {
    request.PartnerId = typeof partner?.value === 'undefined' ? partner : partner.value;
    sname += `/partner:${request.PartnerId}`;
  }
  if (service) {
    request.ServiceClassId = typeof service?.value === 'undefined' ? service : service.value;
    sname += `/service:${request.ServiceClassId}`;
  }
  if (isSub) {
    request.IsSubAgent = true;
    sname += `/isSub:${request.IsSubAgent}`;
  }
  return {
    request,
    sname,
  };
}

export default function ({ name, model = {}, formatting } = {}) {
  const url = `/tourclient/masteragent/dictionary/${name}/list`;
  const { request, sname } = getDataRequest(model, name);
  return api
    .post(
      url,
      `request=${encodeURIComponent(JSON.stringify(request))}&removeZero=true`,
      {
        id: `dictionary/${name}${sname}`,
        time: 1,
        formatting,
      },
    );
}
